// 3_pages/brand_page.js
// Brand / manufacturer detail page (body.type-manufacturer-detail): adds the
// sorting-form toggle to the product listing and re-adds it whenever Shoptet
// re-renders the page content.

export function init() {
	if (!window.NAT?.utils?.addSmartTouchClickListener) {
		console.warn("[NAT] brand_page.js: window.NAT.utils.addSmartTouchClickListener missing — check load order");
		return;
	}
	if (!document.body.classList.contains("type-manufacturer-detail")) return;

	editProductSorting();
	document.addEventListener("ShoptetDOMPageContentLoaded", function (event) {
		editProductSorting();
	});
}

// Duplicated from old main.js:1559 — also used by 3_pages/category_filters.js and
// defined in 3_pages/category_listing.js; modules cannot import from each other.
function editProductSorting() {
	let categoryHeader = document.querySelector("#category-header");
	if (!categoryHeader) return;

	let sortingForm = categoryHeader.querySelector(".listSorting");
	if (!sortingForm) return;

	let activeOSortingInput = categoryHeader.querySelector(".listSorting__control--current");
	if (!activeOSortingInput) return;

	const toggleOpenSortingForm = document.createElement("span");
	toggleOpenSortingForm.className = "toggle-open-sorting-form";
	activeOSortingInput.parentElement.append(toggleOpenSortingForm);

	// Add event listener to the toggle button
	window.NAT.utils.addSmartTouchClickListener(toggleOpenSortingForm, function () {
		sortingForm.classList.toggle("active");
		toggleOpenSortingForm.classList.toggle("active");
	});
}
